import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { GtmService } from '../../../shared/services/gtm/gtm.service';
import {
  MIN_STATUS,
  TPV_CURRENCY,
  TPV_TRANSACTION_TYPE,
} from '../../../shared/utils/constants';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { CommonService } from '../../../vass-core/services/common.service';
import { UploadFileComponent } from '../../components/modals/upload-file/upload-file.component';
import { AppraisalModel } from '../../models/appraisal.model';
import { AppraisalService } from '../../services/appraisal/appraisal.service';
import { mapMortgageAppraisal } from './appraisal.mapper';
import { AppraisalFormComponent } from './components/appraisal-form/appraisal-form.component';
import { AppraisalModalComponent } from './components/appraisal-modal/appraisal-modal.component';
import { ModalErrorTpvComponent } from './components/modal-error-tpv/modal-error-tpv.component';

import { distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-appraisal',
  templateUrl: './appraisal.component.html',
  styleUrls: ['./appraisal.component.scss'],
  standalone: false,
})
export class AppraisalComponent implements OnInit, OnDestroy {
  @ViewChild('appraisalForm') appraisalForm: AppraisalFormComponent;
  @ViewChild('formTPV', { static: true }) formTPV: ElementRef;

  public appraisal: AppraisalModel;
  public httpError: boolean;
  public hasFinished: boolean;
  public status: number;
  public minStatus = MIN_STATUS;
  private showLoader = true;
  private subscription = new Subscription();

  public tpv: UntypedFormGroup;
  public urlTPV: string;

  constructor(
    private _commonService: CommonService,
    private appraisalService: AppraisalService,
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private translate: TranslateService,
    private gtm: GtmService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.getStatus();
    this.getAppraisal();

    this.urlTPV = environment.urlTPV;

    this.tpv = this.fb.group({
      Ds_SignatureVersion: ['', Validators.required],
      Ds_MerchantParameters: ['', Validators.required],
      Ds_Signature: ['', Validators.required],
    });
    this.getParamsTPV();
  }

  getParamsTPV() {
    if (this.status) {
      const statusTPV = this.route.snapshot.params['status'];
      if (this.status === MIN_STATUS.appraisal) {
        if (statusTPV === 'error') {
          console.log('mostrar una modal generica informando del error');
          this.openModalErrorTPV();
        } else if (statusTPV === 'success') {
          console.log('avanzar el estado');
          const data = {
            appraisalConditions: true,
            Ds_SignatureVersion: this.route.snapshot.queryParams['Ds_SignatureVersion'],
            Ds_MerchantParameters:
              this.route.snapshot.queryParams['Ds_MerchantParameters'],
            Ds_Signature: this.route.snapshot.queryParams['Ds_Signature'],
          };
          this.aprraisalAccepted(data);

          // PRUEBA PARA CONFIRMAR PAGO
          // this.appraisalService.confirmTPV({
          //     Ds_SignatureVersion: this.route.snapshot.queryParams['Ds_SignatureVersion'],
          //     Ds_MerchantParameters: this.route.snapshot.queryParams['Ds_MerchantParameters'],
          //     Ds_Signature: this.route.snapshot.queryParams['Ds_Signature']
          // });
        }
      }
    } else {
      const subscription = this.authService.getStatus().subscribe((_status) => {
        if (this.status) {
          this.getParamsTPV();
          if (subscription) {
            subscription.unsubscribe();
          }
        }
      });
    }
  }

  private getStatus() {
    this.subscription.add(
      this.authService
        .getStatus()
        .pipe(distinctUntilChanged())
        .subscribe((response) => {
          this.status = parseInt(response, 10);
          this.gtm.sendVarGTM({ pageType: 'En tasación' });
        }),
    );
  }

  private getAppraisal() {
    this.subscription.add(
      this.appraisalService.getAppraisal().subscribe(
        (response) => {
          if (response) {
            this.appraisal = response;
          }
        },
        (error) => (this.httpError = true),
      ),
    );
  }

  public onEmitHasSimpleNote(simpleNote) {
    this.appraisal.mortgagesAppraisalData.simpleNote = simpleNote;
  }

  public onEmitHasAppraisal(appraisal) {
    this.appraisal.mortgagesAppraisalData.appraisal = appraisal;
  }

  public onEmitAppraisalAmount(appraisalAmount) {
    this.appraisal.mortgagesAppraisalData.appraisalAmount = appraisalAmount;
  }

  public onEmitMortgageAppraisalData(mortgageAppraisalData) {
    this.appraisal.mortgagesAppraisalData = <any>(
      mapMortgageAppraisal(mortgageAppraisalData, this.appraisal)
    );
    this.subscription.add(
      this.appraisalService
        .saveAppraisal(this.appraisal.mortgagesAppraisalData)
        .subscribe((response) => this.openAppraisalModal()),
    );
  }

  public onEmitMortgageAppraisalDataSave(mortgageAppraisalData) {
    const summary = this.translate.instant('toast_component_send');
    const detail = this.translate.instant('toast_component_save_success');

    this.appraisal.mortgagesAppraisalData = <any>(
      mapMortgageAppraisal(mortgageAppraisalData, this.appraisal)
    );
    this.subscription.add(
      this.appraisalService
        .saveAppraisal(this.appraisal.mortgagesAppraisalData, this.showLoader)
        .subscribe((response) => {
          this._commonService.sendNotification({
            key: 'save-document-ok',
            severity: 'success',
            position: 'top-center',
            summary: summary,
            time: 5000,
            detail: detail,
          });
          this.showLoader = true;
          this.gtm.sendEventGTM({
            event: 'interaccion',
            eAction: 'tasacion',
            eLabel: 'enviar',
          });
        }),
    );
  }

  public onEmitMorgageAprraisalFile(isSimpleNote) {
    this.subscription.add(
      this.appraisalService
        .saveAppraisal(this.appraisal.mortgagesAppraisalData)
        .subscribe(),
    );
  }

  private openAppraisalModal() {
    const options: Object = {
      txtButton: '',
      showHeader: true,
      header: this.appraisal.mortgagesAppraisalData.appraisal
        ? this.translate.instant('appraisal_form_hasAppraisal_appraisal')
        : this.translate.instant('appraisal_form_request_appraisal'),
      closeOnEscape: false,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    const data: any = {
      appraisalCost: this.appraisal.mortgagesAppraisalCrmData.appraisalCost,
      hasAppraisal: this.appraisal.mortgagesAppraisalData.appraisal,
    };

    this.confirmationService.confirm(<any>{
      component: AppraisalModalComponent,
      options,
      data,
      accept: (data) => {
        // si no aporta nota simple navegar a redsys
        if (!this.appraisal.mortgagesAppraisalData.appraisal) {
          this.appraisalService
            .buildRequestTPV({
              amount: String(this.appraisal.mortgagesAppraisalCrmData.appraisalCost),
              divisa: TPV_CURRENCY,
              transactionType: TPV_TRANSACTION_TYPE,
            })
            .subscribe((data) => {
              this.tpv.patchValue(data);
              if (this.tpv.valid) {
                this.formTPV.nativeElement.submit();
              }
            });
        } else {
          // Si aporta tasacion avanzar el caso
          this.aprraisalAccepted({
            appraisalConditions: true,
            Ds_SignatureVersion: '',
            Ds_MerchantParameters: '',
            Ds_Signature: '',
          });
        }
      },
      reject: () => {},
    });
  }

  private aprraisalAccepted(data) {
    this.subscription.add(
      this.appraisalService.setChecks(data).subscribe((response) => {
        this.authService.updateStatus(true);
        this.getStatus();
        this.getAppraisal();
        window.scrollTo(0, 0);
      }),
    );
  }

  public saveAppraisal() {
    this.appraisalForm.submitAppraisalForm(true);
  }

  public sendAppraisal() {
    this.appraisalForm.submitAppraisalForm();
  }

  openModalUpload(typeFile: string) {
    const options: Object = {
      txtButton: '',
      showHeader: true,
      header: this.translate.instant(typeFile),
      closeOnEscape: false,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
      maxWidth: 900,
    };

    const data = {
      category: 'MTG_C03',
      type: 'DOC_16',
      searchByCategory: false,
    };
    if (typeFile === 'appraisal_form_upload_appraisal') {
      data.type = 'DOC_17';
    }

    this.confirmationService.confirm(<any>{
      component: UploadFileComponent,
      options,
      data: data,
      accept: (data) => {
        if (data) {
          const detail = this.translate.instant('toast_component_upload_success');
          const summary = this.translate.instant('toast_component_send');
          this._commonService.sendNotification({
            key: 'save-document-ok',
            severity: 'success',
            position: 'top-center',
            summary: summary,
            time: 5000,
            detail: detail,
          });
          this.showLoader = false;
          this.appraisalForm.submitAppraisalForm(true);
        }
      },
      reject: () => {},
    });
  }

  openModalErrorTPV() {
    const titleModal = this.translate.instant('title_error_modal_tpv');

    const data = {
      showIcon: true,
    };
    const options: Object = {
      header: titleModal,
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalErrorTpvComponent,
      options: options,
      data: data,
      accept: (data) => {
        setTimeout(() => {
          this.openAppraisalModal();
        }, 100);
      },
      reject: () => {},
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
